import styled from '@emotion/styled';

export const StyledWrapper = styled.div<{ isTopMargin?: boolean }>`
  margin-top: ${({ isTopMargin }) => isTopMargin && '20px'};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
`;
